import { z } from "zod";

export const weeklyRecapResponseSchema = z.object({
	id: z.string(),
	user_id: z.string(),
	week_key: z.string(),
	posts_count: z.number().int().nonnegative(),
	comments_count: z.number().int().nonnegative(),
	reactions_given: z.number().int().nonnegative(),
	reactions_received: z.number().int().nonnegative(),
	xp_gained: z.number().int().nonnegative(),
	streak_at_send: z.number().int().nonnegative(),
	sent_at: z.number().int().positive().nullable(),
	created_at: z.number().int().positive(),
});

export type WeeklyRecapResponse = z.infer<typeof weeklyRecapResponseSchema>;
